import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { store } from '../App';
import { apiUrl } from './Constants';
import '../css/NextSteps.css';

const FALLBACK_NEXT_STEPS = {
  section_title_en: "YOUR NEXT STEPS",
  section_title_ar: "خطواتك التالية",
  steps: [
    {
      id: 1,
      title_en: "REQUEST BROCHURE",
      title_ar: "طلب الكتيب",
      subtitle_en: null,
      subtitle_ar: null,
      icon: "fa fa-book",
      icon_file: null,
      link: "/request-brochure",
      link_target: "_self",
      sort_order: 1,
      status: 1
    },
    {
      id: 2,
      title_en: "FIND A SHOWROOM",
      title_ar: "ابحث عن صالة عرض",
      subtitle_en: null,
      subtitle_ar: null,
      icon: "fa fa-map-marker",
      icon_file: null,
      link: "/showrooms",
      link_target: "_self",
      sort_order: 2,
      status: 1
    },
    {
      id: 3,
      title_en: "BOOK A TEST DRIVE",
      title_ar: "احجز تجربة قيادة",
      subtitle_en: null,
      subtitle_ar: null,
      icon: "fa fa-car",
      icon_file: null,
      link: "/book-a-test-drive",
      link_target: "_self",
      sort_order: 3,
      status: 1
    },
    {
      id: 4,
      title_en: "REQUEST QUOTE",
      title_ar: "طلب عرض أسعار",
      subtitle_en: null,
      subtitle_ar: null,
      icon: "fa fa-file-text-o",
      icon_file: null,
      link: "/request-a-quote",
      link_target: "_self",
      sort_order: 4,
      status: 1
    },
    {
      id: 5,
      title_en: "CALL TOLL FREE",
      title_ar: "اتصل بنا مجاناً",
      subtitle_en: null,
      subtitle_ar: null,
      icon: "fa fa-phone",
      icon_file: null,
      link: "tel:80000000",
      link_target: "_self",
      sort_order: 5,
      status: 1
    },
    {
      id: 6,
      title_en: "GET US ON WHATSAPP",
      title_ar: "تواصل معنا عبر واتساب",
      subtitle_en: null,
      subtitle_ar: null,
      icon: "fa fa-whatsapp",
      icon_file: null,
      link: "https://wa.me/96800000000",
      link_target: "_blank",
      sort_order: 6,
      status: 1
    }
  ]
};

// Render icons matching the design and API
const renderStepIcon = (step) => {
  if (step?.icon_file) {
    const fileUrl = step.icon_file.startsWith('http') || step.icon_file.startsWith('/')
      ? step.icon_file
      : `https://dev10.sbagh.com/public/images/next_steps/${step.icon_file}`;
    return <img src={fileUrl} alt={step.title_en || 'Step Icon'} className="next-step-icon-img" />;
  }

  const iconName = String(step?.icon || '').toLowerCase();

  // 1. Book / Brochure
  if (iconName.includes('book')) {
    return (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
      </svg>
    );
  }

  // 2. Location / Showroom
  if (iconName.includes('map') || iconName.includes('marker') || iconName.includes('location') || iconName.includes('showroom')) {
    return (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    );
  }

  // 3. Car / Test Drive
  if (iconName.includes('car') || iconName.includes('drive')) {
    return (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 14c0-1.1.9-2 2-2h1.5l1.6-4.2C8.4 7.3 9 7 9.7 7h4.6c.7 0 1.3.3 1.6.8L17.5 12H19c1.1 0 2 .9 2 2v2a1 1 0 0 1-1 1h-1.2a2.8 2.8 0 0 1-5.6 0H9.8a2.8 2.8 0 0 1-5.6 0H3a1 1 0 0 1-1-1v-2z" />
        <circle cx="7" cy="16.5" r="1.5" />
        <circle cx="17" cy="16.5" r="1.5" />
      </svg>
    );
  }

  // 4. Quote / Document
  if (iconName.includes('file') || iconName.includes('doc') || iconName.includes('quote')) {
    return (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="8" y1="13" x2="16" y2="13" />
        <line x1="8" y1="17" x2="16" y2="17" />
        <line x1="8" y1="9" x2="11" y2="9" />
      </svg>
    );
  }

  // 5. Phone / Toll Free
  if (iconName.includes('phone') || iconName.includes('call') || iconName.includes('toll')) {
    return (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    );
  }

  // 6. WhatsApp
  if (iconName.includes('whatsapp')) {
    return (
      <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        <path d="M9.5 8.8c.2-.4.4-.4.6-.4h.5c.2 0 .4.1.5.4l.6 1.5c.1.3.1.5-.1.7l-.4.5c-.1.2-.2.3-.1.6.4.7 1 1.3 1.7 1.7.3.2.4 0 .6-.1l.5-.4c.2-.2.4-.2.7-.1l1.5.6c.3.1.4.3.4.5v.5c0 .2 0 .4-.4.6-.5.3-1.3.5-2.2.1-1.3-.5-2.5-1.7-3.3-3-.6-1-.5-1.8-.1-2.3z" fill="currentColor" stroke="none" />
      </svg>
    );
  }

  // Fallback to FontAwesome class
  if (step?.icon) {
    return <i className={step.icon} />;
  }

  return (
    <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="12" cy="12" r="10" />
    </svg>
  );
};

export default function NextSteps() {
  const [lang] = useContext(store);
  const [nextSteps, setNextSteps] = useState(FALLBACK_NEXT_STEPS);

  useEffect(() => {
    const endpoint = apiUrl ? `${apiUrl}getNextSteps` : 'https://dev10.sbagh.com/api/getNextSteps';

    axios
      .get(endpoint)
      .then((response) => {
        if (response?.data?.data) {
          setNextSteps(response.data.data);
        }
      })
      .catch((err) => {
        console.warn('Could not load next steps data, using fallback:', err?.message);
      });
  }, []);

  const sectionTitle = lang
    ? nextSteps?.section_title_ar || FALLBACK_NEXT_STEPS.section_title_ar
    : nextSteps?.section_title_en || FALLBACK_NEXT_STEPS.section_title_en;

  const rawSteps = nextSteps?.steps && Array.isArray(nextSteps.steps) && nextSteps.steps.length > 0
    ? nextSteps.steps
    : FALLBACK_NEXT_STEPS.steps;

  // Filter active steps and sort by sort_order
  const steps = rawSteps
    .filter((s) => s.status === undefined || s.status === 1 || s.status === '1' || s.status === true)
    .sort((a, b) => (Number(a.sort_order) || 0) - (Number(b.sort_order) || 0));

  if (!steps || steps.length === 0) {
    return null;
  }

  return (
    <section className={`next-steps-section ${lang ? 'rtl' : 'ltr'}`}>
      <div className="next-steps-container">
        {/* Section Header */}
        <div className="next-steps-header" data-aos="fade-up">
          <h2 className="next-steps-title">{sectionTitle}</h2>
          <div className="next-steps-divider" />
        </div>

        {/* Steps Grid */}
        <div className="next-steps-grid">
          {steps.map((step, idx) => {
            const title = lang
              ? step.title_ar || step.title_en
              : step.title_en || step.title_ar;
            const subtitle = lang ? step.subtitle_ar : step.subtitle_en;
            const link = step.link || '#';
            const target = step.link_target || '_self';
            const isExternal =
              link.startsWith('http://') ||
              link.startsWith('https://') ||
              link.startsWith('tel:') ||
              link.startsWith('mailto:') ||
              target === '_blank';

            const innerContent = (
              <>
                <div className="next-step-circle">
                  {renderStepIcon(step)}
                </div>
                <h3 className="next-step-title">{title}</h3>
                {subtitle && <span className="next-step-subtitle">{subtitle}</span>}
              </>
            );

            if (isExternal) {
              return (
                <a
                  key={step.id || idx}
                  href={link}
                  target={target}
                  rel={target === '_blank' ? 'noopener noreferrer' : undefined}
                  className="next-step-item"
                  data-aos="fade-up"
                  data-aos-delay={(idx % 4) * 100}
                  title={title}
                >
                  {innerContent}
                </a>
              );
            }

            return (
              <Link
                key={step.id || idx}
                to={link}
                className="next-step-item"
                data-aos="fade-up"
                data-aos-delay={(idx % 4) * 100}
                title={title}
              >
                {innerContent}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
